module.exports = __webpack_public_path__ + "images/huiskes_smallaf55f35c36e52a332d8e3ec7bd785ace.png";